export default __webpack_public_path__ + "static/media/close_modal.fa9ac037.svg";